export const formatNumber = (value, locale = "en-US") => {
    if (isNaN(value)) {
        return "";
    }
    return value.toLocaleString(locale);
};
